import { ReactElement, ReactNode } from 'react';
import { ExportToDocumentationDialog } from './ExportToDocumentationDialog';
import { ExportToDocumentationProvider } from './ExportToDocumentationContext';

/**
 * Mount point for export-to-documentation (provider + dialog).
 *
 * Issue-only: requires `withIssue` and issue route params.
 * Do not mount on inspection/template views — `ExportToDocumentationDialog` calls
 * `useCurrentIssue()` and will throw outside `WithIssue` (PT-7064).
 *
 * Gallery tiles use `useExportToDocumentationOptional()`; without this provider
 * the export action is hidden (no crash, no no-op dialog).
 */
export function WithExportToDocumentation({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  return (
    <ExportToDocumentationProvider>
      {children}
      <ExportToDocumentationDialog />
    </ExportToDocumentationProvider>
  );
}
